(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-lesson"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('atelier-lesson')){
    class AtelierLesson extends HTMLElement{
      connectedCallback(){
        this.start=()=>{
          this.setupGallery();
          const bar=this.querySelector('[data-atl-sticky]');
          const hero=this.querySelector('[data-atl-hero-action]');
          const booking=document.getElementById('lesson-booking');
          if(!bar||!hero||!booking||!('IntersectionObserver'in window))return;
          let passedHero=false;
          let inBooking=false;
          const update=()=>{bar.hidden=!passedHero||inBooking;};
          this.heroObserver=new IntersectionObserver(entries=>{const entry=entries[0];passedHero=!entry.isIntersecting&&entry.boundingClientRect.top<0;update();});
          this.bookingObserver=new IntersectionObserver(entries=>{inBooking=entries[0].isIntersecting;update();},{rootMargin:'0px 0px -10% 0px'});
          this.heroObserver.observe(hero);
          this.bookingObserver.observe(booking.closest('product-info')||booking);
        };
        if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.start,{once:true});else this.start();
      }
      setupGallery(){
        this.galleryEvents?.abort();
        this.galleryResize?.disconnect();
        const gallery=this.querySelector('[data-atl-gallery]');
        const track=gallery?.querySelector('[data-atl-gallery-track]');
        const slides=track?.querySelectorAll('[data-atl-gallery-slide]');
        if(!track||!slides||slides.length<2)return;
        const controls=gallery.querySelector('[data-atl-gallery-controls]');
        const previous=gallery.querySelector('[data-atl-gallery-previous]');
        const next=gallery.querySelector('[data-atl-gallery-next]');
        const current=gallery.querySelector('[data-atl-gallery-current]');
        const status=gallery.querySelector('[data-atl-gallery-status]');
        this.galleryEvents=new AbortController();
        const signal=this.galleryEvents.signal;
        const reducedMotion=window.matchMedia('(prefers-reduced-motion:reduce)');
        let index=0;
        const update=(announce=false)=>{
          current.textContent=String(index+1);
          previous.disabled=index===0;
          next.disabled=index===slides.length-1;
          if(announce)status.textContent=status.dataset.statusTemplate.replace('[current]',String(index+1));
        };
        const goTo=(requested)=>{
          index=Math.min(slides.length-1,Math.max(0,requested));
          track.scrollTo({left:index*track.clientWidth,behavior:reducedMotion.matches?'instant':'smooth'});
          update(true);
        };
        previous.addEventListener('click',()=>goTo(index-1),{signal});
        next.addEventListener('click',()=>goTo(index+1),{signal});
        track.addEventListener('keydown',event=>{
          const destinations={ArrowLeft:index-1,ArrowRight:index+1,Home:0,End:slides.length-1};
          if(!(event.key in destinations))return;
          event.preventDefault();
          goTo(destinations[event.key]);
        },{signal});
        track.addEventListener('scroll',()=>{
          clearTimeout(this.galleryScrollTimer);
          this.galleryScrollTimer=setTimeout(()=>{
            const nextIndex=Math.min(slides.length-1,Math.max(0,Math.round(track.scrollLeft/Math.max(track.clientWidth,1))));
            if(nextIndex!==index){index=nextIndex;update(true);}
          },140);
        },{signal,passive:true});
        if('ResizeObserver'in window){
          this.galleryResize=new ResizeObserver(()=>{track.scrollTo({left:index*track.clientWidth,behavior:'instant'});});
          this.galleryResize.observe(track);
        }
        controls.hidden=false;
        gallery.classList.add('is-enhanced');
        update();
      }
      disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this.start);this.heroObserver?.disconnect();this.bookingObserver?.disconnect();this.galleryEvents?.abort();this.galleryResize?.disconnect();clearTimeout(this.galleryScrollTimer);}
    }
    customElements.define('atelier-lesson',AtelierLesson);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bouquet-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bouquet-community')) {
    customElements.define('bouquet-community', class extends HTMLElement {
      connectedCallback() {
        this.tourAbort?.abort();
        this.tourAbort = new AbortController();
        const eventOptions = { signal: this.tourAbort.signal };
        const tabs = [...this.querySelectorAll('[data-bq-tour-tab]')];
        const panels = [...this.querySelectorAll('[data-bq-tour-panel]')];
        const tablist = this.querySelector('[data-bq-tour-tabs]');
        const selectTab = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        if (tabs.length && tabs.length === panels.length) {
          selectTab(0);
          tablist.hidden = false;
          tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => selectTab(i), eventOptions);
            tab.addEventListener('keydown', event => {
              let next;
              if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
              if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = tabs.length - 1;
              if (next !== undefined) { event.preventDefault(); selectTab(next, true); }
            }, eventOptions);
          });
        }
        const dialog = this.querySelector('[data-bq-screen-dialog]');
        if (dialog && typeof dialog.showModal === 'function') {
          this.querySelectorAll('[data-bq-enlarge-src]').forEach(button => {
            button.hidden = false;
            button.addEventListener('click', () => {
              const image = document.createElement('img');
              image.src = button.dataset.bqEnlargeSrc;
              image.alt = button.dataset.bqEnlargeAlt;
              dialog.querySelector('[data-bq-enlarged-image]').replaceChildren(image);
              dialog.showModal();
            }, eventOptions);
          });
        }
        const sticky = this.querySelector('[data-bq-sticky]');
        const hero = this.querySelector('[data-bq-hero-cta]');
        const final = this.querySelector('[data-bq-final]');
        if (!sticky || !hero || !final || !('IntersectionObserver' in window)) return;
        let heroAbove = false;
        let finalVisible = false;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === hero) heroAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === final) finalVisible = entry.isIntersecting;
          });
          sticky.hidden = !heroAbove || finalVisible;
        });
        this.observer.observe(hero);
        this.observer.observe(final);
      }
      disconnectedCallback() { this.observer?.disconnect(); this.tourAbort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bouquet-world"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bouquet-page')) {
  customElements.define('bouquet-page', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-bqm-zoom]');
        if (link && this.dialog && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          this.opener = link;
          const image = this.dialog.querySelector('[data-bqm-dialog-image]');
          image.src = link.href;
          image.alt = link.querySelector('img')?.alt || '';
          this.dialog.querySelector('[data-bqm-dialog-caption]').textContent = link.dataset.caption || '';
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.dialog.querySelector('button').focus();
        }
      }, options);
      this.dialog?.addEventListener('close', () => {
        this.restoreScroll();
        this.opener?.focus();
      }, options);
      this.dialog?.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.carouselUpdates = [];
      this.querySelectorAll('[data-bqm-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-bqm-track]');
        const controls = carousel.querySelector('[data-bqm-controls]');
        if (!track || !controls) return;
        const previous = controls.querySelector('[data-bqm-prev]');
        const next = controls.querySelector('[data-bqm-next]');
        const count = controls.querySelector('[data-bqm-count]');
        previous.setAttribute('aria-controls', track.id);
        next.setAttribute('aria-controls', track.id);
        const visibleSlides = () => Array.from(track.querySelectorAll('[data-bqm-slide]')).filter(slide => !slide.hidden);
        const update = () => {
          const slides = visibleSlides();
          const bounds = track.getBoundingClientRect();
          const visible = slides.map((slide, index) => ({ index, rect: slide.getBoundingClientRect() })).filter(item => item.rect.left < bounds.right - 20 && item.rect.right > bounds.left + 20);
          const scrollable = track.scrollWidth > track.clientWidth + 2;
          controls.hidden = !scrollable;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          if (visible.length) {
            const first = visible[0].index + 1;
            const last = visible[visible.length - 1].index + 1;
            count.textContent = (first === last ? first : first + '–' + last) + ' / ' + slides.length;
          }
        };
        const move = direction => {
          const slides = visibleSlides();
          const rect = track.getBoundingClientRect();
          const index = slides.findIndex(slide => slide.getBoundingClientRect().left >= rect.left - 2);
          const current = index < 0 ? slides.length - 1 : index;
          const target = slides[Math.max(0, Math.min(slides.length - 1, current + direction))];
          if (target) track.scrollTo({ left: track.scrollLeft + target.getBoundingClientRect().left - rect.left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto' });
          else move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.carouselUpdates.push(update);
        update();
      });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.carouselUpdates.forEach(update => update()));
      this.querySelectorAll('[data-bqm-track]').forEach(track => this.resizeObserver.observe(track));
      this.refreshDates = () => {
        if (this.dataset.designMode === 'true') return;
        const now = Date.now() / 1000;
        const expiry = Number(this.dataset.statusExpiry);
        if (expiry && now >= expiry) {
          this.querySelectorAll('[data-bqm-status]').forEach(el => { el.textContent = this.dataset.fallbackStatus; });
          this.querySelectorAll('[data-bqm-cta]').forEach(el => {
            if (this.dataset.lineUrl) {
              el.href = this.dataset.lineUrl;
              el.querySelector('span').textContent = this.dataset.lineLabel;
            } else el.hidden = true;
          });
          this.querySelectorAll('[data-bqm-cta-note]').forEach(el => { el.textContent = this.dataset.lineNote; });
        }
        this.querySelectorAll('[data-bqm-schedule]').forEach(section => {
          const rows = Array.from(section.querySelectorAll('[data-bqm-event]'));
          rows.forEach(row => { if (Number(row.dataset.expiry) <= now) row.hidden = true; });
          const any = rows.some(row => !row.hidden);
          section.querySelector('[data-bqm-event-list]').hidden = !any;
          const carousel = section.querySelector('[data-bqm-event-carousel]');
          if (carousel) carousel.hidden = !any;
          section.querySelector('[data-bqm-schedule-empty]').hidden = any;
        });
        this.querySelectorAll('[data-bqm-trip-next]').forEach(el => { if (Number(el.dataset.expiry) <= now) el.hidden = true; });
        this.carouselUpdates.forEach(update => update());
      };
      this.refreshDates();
      this.carouselUpdates.forEach(update => update());
      document.addEventListener('visibilitychange', this.refreshDates, options);
      this.timer = setInterval(this.refreshDates, 60000);
    }
    restoreScroll() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); this.resizeObserver?.disconnect(); this.restoreScroll(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hanakatsu-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hanakatsu-landing')) {
    customElements.define('hanakatsu-landing', class extends HTMLElement {
      connectedCallback() {
        const heroCta = this.querySelector('.hklp__hero-cta');
        const final = this.querySelector('.hklp__final');
        const sticky = this.querySelector('.hklp__sticky');
        if (!heroCta || !final || !sticky || !('IntersectionObserver' in window)) return;
        let passedHero = false;
        let finalVisible = false;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === heroCta) passedHero = entry.boundingClientRect.bottom < 0;
            if (entry.target === final) finalVisible = entry.isIntersecting;
          });
          sticky.hidden = !passedHero || finalVisible;
        });
        this.observer.observe(heroCta);
        this.observer.observe(final);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hanakatsu-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hanakatsu-product')) {
    customElements.define('hanakatsu-product', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          const hero = this.querySelector('.hkp__hero-cta');
          const booking = document.getElementById('hanakatsu-booking')?.closest('product-info');
          const sticky = this.querySelector('.hkp__sticky');
          if (!hero || !booking || !sticky || !('IntersectionObserver' in window)) return;
          let passed = false;
          let bookingVisible = false;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.target === hero) passed = entry.boundingClientRect.bottom < 0;
              if (entry.target === booking) bookingVisible = entry.isIntersecting;
            });
            sticky.hidden = !passed || bookingVisible;
          });
          this.observer.observe(hero);
          this.observer.observe(booking);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.start();
      }
      disconnectedCallback() { this.observer?.disconnect(); document.removeEventListener('DOMContentLoaded', this.start); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (this.header.classList.contains('menu-open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
